import { useRouter } from "next/router";
import type { DealInfo as KtDealInfo } from "~/utils/NyukyoshaKanriUrlUtil";
import { getDealInfoFromUrlSearchParams } from "~/utils/NyukyoshaKanriUrlUtil";

type DealInfo = KtDealInfo & {
	isReady: boolean;
};

export const useDealInfoFromRouter = (): DealInfo => {
	const router = useRouter();
	const urlSearchParams = new URLSearchParams(
		router.asPath.split("?")[1] ?? ""
	);
	const ktParams = getDealInfoFromUrlSearchParams(urlSearchParams);
	return {
		dealType: ktParams.dealType,
		isReady: router.isReady,
		leasingId: ktParams.leasingId
	};
};
